class ReactorEvent{
    constructor(name){
        this.name = name;
        this.callbacks = [];
    }
    registerCallback(callback){
        this.callbacks.push(callback);
    }
}

function getWords(string){
    let w = string.replace(/[\,\s\|]+/, ' ').split(' ');
    return w;
}

class Reactor{
    static Trait(classObj){
        classObj.prototype.registerEvents = Reactor.prototype.registerEvents
        classObj.prototype.dispatchEvent = Reactor.prototype.dispatchEvent
        classObj.prototype.addEventListener = Reactor.prototype.addEventListener
    }
}

Reactor.prototype.registerEvents = function(...events){
    if(!this.events){
        this.events = {}
    }
    for(const eventObject of events){
        for(const eventName of getWords(eventObject)){
            this.events[eventName] = new ReactorEvent(eventName);
        }
    }
};

Reactor.prototype.dispatchEvent = function(eventName, eventArgs){
    const event = this.events[eventName]
    event.callbacks.forEach(function(callback){
        callback(Object.assign({}, event, {args: eventArgs}));
    });
};

Reactor.prototype.addEventListener = function(events, callback){
    for(const eventName of getWords(events)){
        this.events[eventName].registerCallback(callback);
    }
};

export {Reactor};